import { APIS_LIST } from "./ChatModels";
import { LOADER_OPTIONS } from "./LoaderModel";
import { ProjectStatus } from "./ProjectModel";

// context 
export interface MainContextInterface { 
  loadersList: string[];
  modifyLoaders: (value: string, type: LOADER_OPTIONS) => void;
}

// Theme Context
export interface ThemeContextInterface { 
  themeName: string;
  modifyTheme: (value: string) => void;
}

export enum ThemeTypes {
  DARK_THEME = 'dark',
  BLUE_THEME = 'blue'
}

// Projects Models
export enum ProjectTypeEnum {
  DOCUMENT_AI = 'document_ai',
  DATA_ANALYTICS = 'data_analytics',
  RESEARCH_INSIGHTS= 'research_insights',
  EBOOK__INSIGHTS= 'ebook_insights'
  // LANDING= 'landing'
  // AI_TOOLS = 'ai_tools'
}


// this will be Production/Demo instance 
// https://workforce.aviralabs.ai/
// disable-- ebook | 
// disable-- data insights

// this will be our development instance
// https://my-api.aviralabs.ai/
// display only-- ebook
 
export enum ProjectTypeEnum1 {
  // DOCUMENT_AI = 'document_ai',
  // DATA_ANALYTICS = 'data_analytics',
  // RESEARCH_INSIGHTS= 'research_insights',
  EBOOK__INSIGHTS= 'ebook_insights'
  // LANDING= 'landing'
  // AI_TOOLS = 'ai_tools'
}

export enum ProjectTypeEnum2 {
  DOCUMENT_AI = 'document_ai',
  // DATA_ANALYTICS = 'data_analytics',
  RESEARCH_INSIGHTS= 'research_insights',
  // EBOOK__INSIGHTS= 'ebook_insights'
}



// Need to change flagsCount
export interface IProjectModel {
  project_id: string;
  project_name: string;
  label?: string;
  project_description?: string;
  project_type: ProjectTypeEnum;
  project_status?: ProjectStatus | string;
  version: string;
  apiCount?: number;
  no_of_elements?: number;
  production_date?: string;
  modified_date?: string;
  flag_count: any; 
  user_id?:string;
  username?:string;
  open_ai_key?:string;
  temperature?:any;
  engine?:string;
  model?:string;
  temparature?:any ;
  embeddedModal?:string;
  chunk_overlap?:any;
  chunk_size?:any;
  llamaparse_api_key?:string;
}

export enum engineTypes{
  OPEN_AI = 'open_ai',
  OPEN_SOURCE = 'open_source'
}

export enum openAITypes{    
    GPT4TURBOPREVIEW = 'gpt-4-turbo-preview',
    GPT432K = 'gpt-4-32k',

    GPT35TURBO16K0613 = 'gpt-3.5-turbo-16k-0613',
    GPT35TURBO0125 = 'gpt-3.5-turbo-0125',
    GPT4 = 'gpt-4',
    
    GPT41106VISIONPREVIEW = 'gpt-4-1106-vision-preview',
    GPT4VISIONPREVIEW = 'gpt-4-vision-preview',
}

export const researchInsightsEngineTypes = [openAITypes.GPT4VISIONPREVIEW,openAITypes.GPT432K]
export const docAiEngineTypes = [openAITypes.GPT35TURBO16K0613,openAITypes.GPT35TURBO0125,openAITypes.GPT4,openAITypes.GPT432K]
export const ebookEngyneTypes = [openAITypes.GPT4TURBOPREVIEW]
export const dataanalyticsEngineTypes = [openAITypes.GPT4VISIONPREVIEW,openAITypes.GPT41106VISIONPREVIEW,openAITypes.GPT4TURBOPREVIEW,openAITypes.GPT35TURBO16K0613,openAITypes.GPT35TURBO0125,openAITypes.GPT4,openAITypes.GPT432K,]

export enum openSourceTypes{
  MISTRAL7B='mistral 7b', 
  MISTRAL13BINSTRUCT='mistral 13b instruct'
}

// export enum embeddedModelTypes{
//   ADAV2='ada v2',
//   TEXTEMBEDDING3LARGE='text-embedding-3-large'
// }

export enum embeddedModelTypes{
  ADAV2='open_ai',
  TEXTEMBEDDING3LARGE='open_ai'
}

export const embeddedModelTypesUpdated = [{label:'ada v2', value:'open_ai'}, {label:'text-embedding-3-large', value:'open_ai'}]

export enum openAikeyTypes{
  openAiKey="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",
  llamaparseApiKey="llx-vXspRaEGzkdzTIvKjAZ0Zw4cQ9DIpnQV9uB14K11up234Dse"
}


export interface IWorkSpaceModal{
  workspace_name:string;
  workspace_owner:string;
  list_of_users:string[]
}

export interface IAPIPromptsModel {
  prompt?: string;
  status: boolean;
  type: APIS_LIST;
}

export enum GraphDisplayType {
  SINGLE = 'single',
  ALL = 'all',
  CAROUSEL = 'carousel'
}

export enum DropDownOptions {
  VIEW_LOGS = 'view_logs',
  NEW_VERSION = 'new_version',
  ASSIGN_WORK_SPACE = 'new_version',
}

export interface ILevelNodes {
  level: string | number;
  nodes: (string | number)[];
}

export interface INodesModel {
  id: string | number;
  label: string;
  // title: string;
  levelNodes?: ILevelNodes[];
}

export interface IEdgesModel {
  from: string | number;
  to: string | number;
}

export interface IGraphModel {
  nodes: INodesModel[];
  edges: IEdgesModel[];
}
